import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface CustomFieldGroupDocument extends BaseDocument {
  customFieldTabId: string
  name: string
  description: string | null
  sortOrder: string | null
}

const hooks = createEntityHooks<CustomFieldGroupDocument>('customfieldgroups')

export const useCustomFieldGroups = (filter?: Partial<CustomFieldGroupDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { customFieldGroups: data, isLoading, db }
}

export const useCustomFieldGroup = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { customFieldGroup: data, isLoading }
}

export const useCustomFieldGroupMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createCustomFieldGroup: create,
    updateCustomFieldGroup: update,
    deleteCustomFieldGroup: deleteEntity,
  }
}
